import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource-variable/onest";
import "./telegram-import-rescue.js";
import { App } from "./App.js";
import "./styles.css";
import "./styles-v6.css";

createRoot(document.getElementById("root")!).render(<StrictMode><App /></StrictMode>);
